import useFindSkusQuery from '@/api/queries/useFindSkusQuery';
import { SearchProps } from '@/components/search/useSearch';
import ProductCatalogResults from '@/modules/store/components/ProductCatalogResults';
import { Sku, SkuAssociation } from '@/modules/store/models/Sku';

interface ProductCatalogTableProps extends SearchProps {
  supplierId?: string | string[] | null;
  productCategoryId?: string | string[] | null;
  productCategoryName?: string | string[] | null;
  promotions?: boolean;
  onAddToCart: (sku: Sku, quantity: number) => void;
  storeId?: string | null;
}

const ProductCatalogTable = ({
  searchQuery,
  page = 1,
  onChangePage = () => {},
  supplierId,
  productCategoryId,
  productCategoryName,
  promotions,
  onAddToCart,
  storeId,
}: ProductCatalogTableProps) => {
  const { skus, isLoading, isFetching, itemsPerPage } = useFindSkusQuery(
    page,
    searchQuery,
    {
      supplierId: supplierId || undefined,
      productCategoryId: productCategoryId || undefined,
      productCategoryName: productCategoryName || undefined,
      promotions: promotions,
      status: 'ACTIVE',
    },
    [],
    [SkuAssociation.ALL],
    true,
    storeId,
  );

  return (
    <ProductCatalogResults
      skus={skus}
      isLoading={isLoading}
      isFetching={isFetching}
      page={page}
      itemsPerPage={itemsPerPage}
      onChangePage={onChangePage}
      onAddToCart={onAddToCart}
    />
  );
};

export default ProductCatalogTable;
